export default "__VITE_ASSET__4775dbc7__"